module.exports = __webpack_public_path__ + "img/cast_map_banner.02e0b67c.svg";